export { default } from "./SpanishIcon";
